import { i18n } from '@lingui/core';

export const ROUTE_PATH = '/admin/users/invite';
export const TITLE = i18n._('New Invite');
